import type { ComponentProps, ReactNode } from 'react'
import { cn } from '~/lib/utils'

interface InputProps extends ComponentProps<'input'> {
	icon?: ReactNode
	showLength?: boolean
}

export function Input({ className, type, icon, showLength, maxLength, value, ...props }: InputProps) {
	const currentLength = typeof value === 'string' ? value.length : 0
	const displayLength = showLength && maxLength ? `${currentLength}/${maxLength}` : null

	const inputElement = (
		<input
			type={type}
			data-slot="input"
			maxLength={maxLength}
			value={value}
			className={cn(
				'flex h-[48px] w-full max-w-input border border-navy-100 bg-white py-[6px] font-sans text-[18px] text-black leading-none shadow-none outline-none transition-[color,box-shadow] placeholder:text-dark-grey-100 disabled:cursor-not-allowed disabled:border-border-input-disabled disabled:bg-input-disabled disabled:text-input-disabled-foreground',
				'focus-visible:border-navy-100 focus-visible:outline-none focus-visible:ring-0',
				'aria-invalid:border-navy-100',
				icon ? 'pr-3 pl-[48px]' : 'px-[16px]',
				className,
			)}
			{...props}
		/>
	)

	if (icon) {
		return (
			<div className="relative">
				<div className="pointer-events-none absolute top-1/2 left-[16px] -translate-y-1/2 text-navy-100">{icon}</div>
				{inputElement}
			</div>
		)
	}

	if (displayLength) {
		return (
			<div className="flex flex-col gap-[8px]">
				{inputElement}
				<p className="text-muted-foreground">{displayLength}</p>
			</div>
		)
	}

	return inputElement
}
